export default {
  getterListProductCategory: state => state.listCategory,
  getterListProduct: state => state.listProduct,
  getterListAttribute: state => state.listAttribute,
}
